import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { gameMetaArray } from 'db/data';
import { Carousel, Flex, Typography, Image } from 'antd';
import { ImagePlayer } from 'components/ImagePlayer';
import { YoutubeVideoEmbed } from 'components/YoutubeVideoEmbed';
import { DrawerButton } from 'components/DrawerButton';
import { OverlayComp } from 'components/OverlayComp';
import { Parallax, Background } from 'react-parallax';
export function GamePage() {
	const { gameURL } = useParams();
    const target = gameMetaArray.find((e) => e.url == gameURL);

	return (
		<>
			{target ? (
				<Flex vertical justify="center" gap={100}>
					<Parallax blur={{ min: -8, max: 8 }} bgImage={target.gameDetails.parallaxBanner.toString()} strength={200}>
						<div style={{ textAlign: 'center', padding: '80px', height: 540 }}>
							<img className='shadow' src={target.gameDetails.logo.toString()} width={'100px'} height={"100px"} style={{ borderRadius: '10px', objectFit:"cover", marginTop: "100px"  }} />
							<Typography.Title >{target.title}</Typography.Title>
							<Typography.Paragraph strong>{target.description}</Typography.Paragraph>
							<DrawerButton label="PLAY NOW" drawerTitle="Platforms" items={target.gameDetails.playNowLinks} />
						</div>
					</Parallax>

					<ImagePlayer data={target.gameDetails.carouselImages} width="960px" height="540px" />
					<Flex wrap="wrap" justify="center" gap={30} style={{ padding: '30px 100px' }}>
						{target.gameDetails.videos.map((item, index) => (
							<YoutubeVideoEmbed key={index} src={item.src} caption={item.caption} />
						))}
					</Flex>
					<Flex wrap="wrap" gap={30} justify="center">
						{target.gameDetails.gridImages.map((item, index) => (
							<Image className="shadow" key={index} style={imgStyle} src={String(item)} />
						))}
					</Flex>
				</Flex>
			) : (
				<></>
			)}
		</>
	);
}

const imgStyle: React.CSSProperties = {
	minWidth: "100%",
	width: '100%',
	height: '200px',
	objectFit: 'cover',
	borderRadius: 10,
};

const fixedImg:React.CSSProperties = {
	maxWidth: "100%",
	width:"auto", height: "auto"
}